export const environment = {
    production: false,
    apiUrl: 'https://api-dev-new.scrubvalley.com/api/v2/',
    assetsUrl: 'https://da3p3yls28xuu.cloudfront.net/'
};
